<script lang="ts" setup>
import type { ProductAttributeData } from '~/types/products'

defineProps<{
  attributesData: ProductAttributeData[]
}>()

function formatValue (value: string): string {
  return String(value).replace(/\r\n/g, '\n')
}
</script>

<template>
  <div class="attributes">
    <dl v-for="{ name, value } in attributesData" :key="name">
      <dt>
        <span>{{ name }}</span>
      </dt>
      <dd>
        <div class="pre-wrap">
          {{ formatValue(value) }}
        </div>
      </dd>
    </dl>
  </div>
</template>

<style lang="scss" scoped>
@use 'assets/css/attributes';
</style>
